import React from 'react';
import { connect } from 'react-redux';

import WhyIcauseComponent from '../components/app/WhyIcause/WhyIcause';

import * as actions from '../actions/why-icause';

const WhyIcause = (props) => {
  return (
    <WhyIcauseComponent {...props} />
  );
};

export default connect(({ whyIcause, user }) => ({ whyIcause, user }), actions)(WhyIcause);

